import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { CENTROSCOSTO_LISTA, FACTORESCOSTOSINDIRECTOS_MAIN, CENTROSCOSTO_REPORTES } from 'constants/codigosTransacciones'

import * as CentrosCostoPages from './centros-costo'
import * as FactoresCostosIndirectosPages from './factores-costos-indirectos'
import * as CentrosCostoReportes from './reportes'

export default function ContabilidadCostosPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${CENTROSCOSTO_LISTA}`} component={CentrosCostoPages.ListaPage} />
        <Route path={`/${CENTROSCOSTO_REPORTES}`} component={CentrosCostoReportes.MainPage} />
        <Route path={`/${FACTORESCOSTOSINDIRECTOS_MAIN}`} component={FactoresCostosIndirectosPages.MainPage} />
      </Switch>
    </Suspense>
  )
}
